"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIObserveValues = void 0;
function isIObserveValues(value) {
    if (typeof value.hasProvider !== "function") {
        return false;
    }
    if (typeof value.getProvider !== "function") {
        return false;
    }
    if (typeof value.registerListener !== "function") {
        return false;
    }
    return true;
}
exports.isIObserveValues = isIObserveValues;
//# sourceMappingURL=IObserveValues.js.map